import React, { useState } from 'react';
import { AppBar, Button, Tab, Tabs, Toolbar, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Auth from '../../util/Auth';
import PERMISSIONS_LIST from '../../util/RolesEnum';
import { useSnackbar } from 'notistack/build';
import EditOtherLease from './EditOtherLease';
import OtherLeaseTitle from './OtherLeaseTitle';
import AddIcon from '@material-ui/icons/Add';

const hasPermissions = Auth.hasRole(PERMISSIONS_LIST.WRITE.WRITE_OTHER_LEASE);

export const FormStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: 50,
  },
  TextField: {
    display: 'block',
    marginTop: 10,
    marginBottom: 10,
    paddingRight: '1em',
  },
  Switch: {
    margin: 0,
  },
  BottomBar: {
    display: hasPermissions ? 'flex' : 'none',
    justifyContent: 'space-between',
  },
  positives: {
    display: 'flex',
    flexDirection: 'row',
  },
  SubmitButton: {
    display: hasPermissions ? 'inline-block' : 'none',
    maxWidth: '200px',
    maxHeight: '50px',
    minWidth: '200px',
    float: 'left',
  },
  DeleteButton: {
    display: hasPermissions ? 'inline-block' : 'none',
    maxWidth: '200px',
    maxHeight: '50px',
    minWidth: '200px',
    float: 'right',
  },
  DIButton: {
    display: hasPermissions ? 'inline-block' : 'none',
    maxWidth: '200px',
    maxHeight: '50px',
    minWidth: '200px',
  },
  FormControlLabel: {
    paddingRight: '5em',
  },
  Select: {
    display: 'block',
  },
  FullWidthTextBox: {
    marginBottom: 20,
    marginTop: 20,
  },
  paper: {
    padding: 25,
    marginBottom: '1rem',
    marginTop: '1rem',
  },
  title: {
    color: '#1976d2',
    fontSize: '1.75rem',
    textAlign: 'left',
    textDecoration: 'underline',
  },
}));

function TabContainer(props) {
  return (
    <Typography component='div' style={{  display: "flex", flexDirection: "column" }}>
      {props.children}
    </Typography>
  );
}

const OtherLeaseTabs = ({ match, history }) => {
  const [value, setValue] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        overflowY: 'auto',
    }}>
      <AppBar position='fixed'
              style={{
                display: "flex",
                paddingTop: value === 0 ? 68 : 56,
                height: value === 0 ? 150 : 120
      }}
      >
        <Toolbar
          style={{

            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignSelf: 'flex-start',
            paddingLeft: 215
          }}
        >
          <Tabs
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
          >
            <Tab label='Main' />
            <Tab label='Chain Of Title' />
          </Tabs>
          {value === 0 && (
            <div style={{ display: 'flex', flexDirection: "row" }}>
              <Button
                size={'small'}
                onClick={() => {
                  setModalOpen(true);
                }}
                variant='contained' color='secondary' style={{ float: 'right', marginRight: 3 }}>
                Delete
              </Button>
              <Button form="editLease"
                      size={'small'}
                      variant='contained' color='primary' type='submit' style={{ float: 'right', marginRight: '4px' }}>
                Update
              </Button>
            </div>
          )}
          {value === 1 && (
            <div>
              <AddIcon
                style={{fontSize: '30px',
                  color: '#fff',
                  float: 'right',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  const plusDiv = document.getElementById('myChain');
                  if (plusDiv) {
                    plusDiv.click();
                  }
                }}
                fontSize="small" />
            </div>

          )}
        </Toolbar>
      </AppBar>
      <div style={{
        paddingTop: value === 0 ? 85 : 50,
        position: "static",
        width: "100%",
      }}
      >
      {value === 0 && (
        <TabContainer>
          <EditOtherLease match={match}
                          modalOpen={modalOpen}
                          setModalOpen={setModalOpen}
                          history={history} />
        </TabContainer>
      )}
      {value === 1 && (
        <TabContainer>
          <OtherLeaseTitle match={match} history={history} enqueueSnackbar={enqueueSnackbar} />
        </TabContainer>
      )}
     </div>
    </div>
  );
};

export default OtherLeaseTabs;
